import React from 'react';
import { Lock, CheckCircle, Eye, Play, RefreshCw } from 'lucide-react';

// --- StepCard Component ---
export default function StepCard({ icon: Icon, title, description, quote, status, onClick, onReview, onStartFresh }) {
  const isLocked = status === 'locked';
  const isCompleted = status === 'completed';
  const isActive = status === 'active';
  let statusIcon, statusRing;
  
  if (isLocked) {
    statusIcon = <Lock className="w-5 h-5 text-gray-500" />;
    statusRing = 'bg-gray-200 text-gray-500';
  } else if (isCompleted) {
    statusIcon = <CheckCircle className="w-6 h-6 text-white" />;
    statusRing = 'bg-green-500 text-white';
  } else { // Active
    statusIcon = <Icon className="w-6 h-6 text-white" />;
    statusRing = 'bg-blue-600 text-white ring-4 ring-blue-200';
  }

  let quoteClasses = '';
  if (isLocked) {
    quoteClasses = 'bg-gray-100 border border-gray-200 text-gray-500';
  } else if (isCompleted) {
    quoteClasses = 'bg-green-50 border border-green-200 text-green-700';
  } else { // Active
    quoteClasses = 'bg-blue-50 border border-blue-200 text-blue-700';
  }

  return (
    <div className={`flex flex-col rounded-xl shadow-lg bg-white overflow-hidden transition-all duration-300 ${isLocked ? 'opacity-70' : 'hover:shadow-2xl'}`}>
      {/* Icon and Title */}
      <div className="p-5 flex items-center space-x-4">
        <div className={`flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center ${statusRing} transition-all duration-300`}>
          {statusIcon}
        </div>
        <div>
          <h3 className="text-lg font-bold text-gray-900">{title}</h3>
        </div>
      </div>
      
      {/* Description */}
      <div className="px-5 pb-5 border-b border-gray-200 flex-grow">
        <p className="text-gray-600 text-sm">{description}</p>
      </div>

      {/* Quote */}
      {quote && (
        <div className={`p-4 m-5 rounded-lg text-sm italic ${quoteClasses}`}>
          <span className="font-semibold">Did you know?</span> {quote}
        </div>
      )}

      {/* Action Buttons */}
      <div className="px-5 pb-5 mt-auto flex flex-wrap gap-3">
        {isLocked && (
          <button
            disabled
            className="flex items-center justify-center px-6 py-3 rounded-lg font-bold bg-gray-200 text-gray-500 cursor-not-allowed"
          >
            <Lock className="w-4 h-4 mr-2" />
            Locked
          </button>
        )}
        {isActive && (
          <button
            onClick={onClick}
            className="flex items-center justify-center px-6 py-3 rounded-lg font-bold bg-blue-600 text-white hover:bg-blue-700 shadow-lg"
          >
            <Play className="w-4 h-4 mr-2" />
            {/* Logic for "Start" vs "Continue" */}
            Start
          </button>
        )}
        {isCompleted && (
          <>
            <button
              onClick={onReview}
              className="flex items-center justify-center px-6 py-3 rounded-lg font-bold bg-white text-green-600 border border-green-500 hover:bg-green-50"
            >
              <Eye className="w-4 h-4 mr-2" />
              Review
            </button>
            {/* This will only render if the onStartFresh prop is provided */}
            {onStartFresh && (
                <button
                onClick={onStartFresh}
                className="flex items-center justify-center px-6 py-3 rounded-lg font-bold bg-gray-100 text-gray-700 border border-gray-300 hover:bg-gray-200"
              >
                <RefreshCw className="w-4 h-4 mr-2" />
                Start Fresh
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
}